module.exports = __webpack_public_path__ + "img/nav-back.2ae95b04.svg";